/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA,
  LOAD_PURCHASE_INVOICE,
  CREATE_PURCHASE_INVOICE,
  UPDATE_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PURCHASE_INVOICE_CATEGORY,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION,
  LOAD_PURCHASE_TOTAL,
  LOAD_TOTAL_PAID,
  LOAD_TOTAL_UNPAID,
  LOAD_PURCHASE_BARCODE,
  LOAD_PURCHASE_PRINT_RECEIPT,
  LOAD_PURCHASE_IMPORT_RAM_LIST,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST,
  LOAD_SCAN_BARCODE_LIST,
} from "./constants";

import {
  loadPurchaseInvoice,
  loadPurchaseInvoiceSuccess,
  loadPurchaseInvoiceError,
  createPurchaseInvoiceListSuccess,
  createPurchaseInvoiceListError,
  updatePurchaseInvoiceListSuccess,
  updatePurchaseInvoiceListError,
  deletePurchaseInvoiceListSuccess,
  deletePurchaseInvoiceListError,
  loadPurchaseInvoiceRecordsMetaDataError,
  loadPurchaseInvoiceRecordsMetaDataSuccess,
  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,
  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,
  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,
  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,
  loadPurchaseTotal,
  loadPurchaseTotalSuccess,
  loadPurchaseTotalError,
  loadTotalPaid,
  loadTotalPaidSuccess,
  loadTotalPaidError,
  loadTotalUnPaid,
  loadTotalUnPaidSuccess,
  loadTotalUnPaidError,
  loadPurchaseBarcode,
  loadPurchaseBarcodeSuccess,
  loadPurchaseBarcodeError,
  loadPurchasePrintReceipt,
  loadPurchasePrintReceiptSuccess,
  loadPurchasePrintReceiptError,
  loadPurchaseImportRamList,
  loadPurchaseImportRamListSuccess,
  loadPurchaseImportRamListError,
  loadPurchaseBarcodeUpdateList,
  loadPurchaseBarcodeUpdateListSuccess,
  loadPurchaseBarcodeUpdateListError,
  loadScanBarcodeList,
  loadScanBarcodeListSuccess,
  loadScanBarcodeListError,
} from "./actions";

import {
  loadPurchaseInvoiceDetails,
  createPurchaseInvoiceDetails,
  updatePurchaseInvoiceDetails,
  deletePurchaseInvoiceDetails,
  loadRecordsMetaData,
  loadPartiesTransactionDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadDashboardTransactionsDetails,
  loadTotalPaidDetails,
  loadTotalUnPaidDetails,
  loadTotalSalesDetails,
  loadPurchaseBarcodeDetails,
  loadPurchasePrintReceiptDetails,
  loadPurchaseImportRamDetails,
  loadPurchaseBarcodeUpdateDetails,
  loadScanBarcodeDetails,
} from "./remotes";

function* loadPurchaseInvoiceSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_INVOICE),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPurchaseInvoice(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPurchaseInvoiceDetails, salesInvoiceList);
        // console.log(result, "result");
        if (result) {
          yield put(loadPurchaseInvoiceSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPurchaseInvoiceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPurchasePrintReceiptSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_PRINT_RECEIPT),
    });

    const { explicitLoad } = load;
    const { purchaseReceipt } = explicitLoad || {};
    yield put(loadPurchasePrintReceipt(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPurchasePrintReceiptDetails,
          purchaseReceipt
        );
        // console.log(result, "result");
        if (result) {
          yield put(loadPurchasePrintReceiptSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPurchasePrintReceiptError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadPurchaseImportRamListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_IMPORT_RAM_LIST),
    });

    const { explicitLoad } = load;
    const { purchaseReceipt } = explicitLoad || {};
    yield put(loadPurchaseImportRamList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPurchaseImportRamDetails,
          purchaseReceipt
        );
        // console.log(result, "result");
        if (result) {
          yield put(loadPurchaseImportRamListSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPurchaseImportRamListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadPurchaseBarcodeUpdateDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_BARCODE_UPDATE_LIST),
    });

    const { explicitLoad } = load;
    const { purchaseBarcode } = explicitLoad || {};
    yield put(loadPurchaseBarcodeUpdateList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPurchaseBarcodeUpdateDetails,
          purchaseBarcode
        );
        // console.log(result, "result");
        if (result) {
          yield put(loadPurchaseBarcodeUpdateListSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPurchaseBarcodeUpdateListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadScanBarcodeDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SCAN_BARCODE_LIST),
    });

    const { explicitLoad } = load;
    const { purchaseBarcode } = explicitLoad || {};
    yield put(loadScanBarcodeList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadScanBarcodeDetails,
          purchaseBarcode
        );
        // console.log(result, "result");
        if (result) {
          yield put(loadScanBarcodeListSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadScanBarcodeListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPurchaseBarcodeSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_BARCODE),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPurchaseBarcode(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPurchaseBarcodeDetails, salesInvoiceList);
        // console.log(result, "result");
        if (result) {
          yield put(loadPurchaseBarcodeSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPurchaseBarcodeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDashboardTransactionsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadDashboardTransactions(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadDashboardTransactionsDetails,
          transactionsList
        );
        // console.log(result, "result");
        if (result) {
          yield put(loadDashboardTransactionsSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadDashboardTransactionsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPurchaseTotalDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_TOTAL),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadPurchaseTotal(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalSalesDetails, transactionsList);
        // console.log(result, "result");
        if (result) {
          yield put(loadPurchaseTotalSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPurchaseTotalError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTotalPaidSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TOTAL_PAID),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadTotalPaid(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalPaidDetails, transactionsList);
        // console.log(result, "result");
        if (result) {
          yield put(loadTotalPaidSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadTotalPaidError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadTotalUnPaidSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TOTAL_UNPAID),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadTotalUnPaid(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalUnPaidDetails, transactionsList);
        // console.log(result, "result");
        if (result) {
          yield put(loadTotalUnPaidSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadTotalUnPaidError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartyVendorAddressSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_PARTY_VENDOR_ADDRESS),
    });

    const { explicitLoad } = load;
    const { addressList } = explicitLoad || {};
    yield put(loadPartyVendorAddress(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartyVendorAddressDetails, addressList);
        // console.log(result, "result");
        if (result) {
          yield put(loadPartyVendorAddressSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartyVendorAddressSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PURCHASE_PARTY_VENDOR_ADDRESS),
    });

    const { partyAddress } = create || {};

    if (create) {
      try {
        const result = yield call(
          createPartyVendorAddressDetails,
          partyAddress
        );
        if (result) {
          yield put(createPartyVendorAddressSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPartiesTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPartiesTransactionDetails,
          salesInvoiceList
        );
        // console.log(result, "result");
        if (result) {
          yield put(loadPartiesTransactionSuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPartiesTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PURCHASE_INVOICE),
    });

    const { salesInvoiceList } = create || {};

    if (create) {
      try {
        const result = yield call(
          createPurchaseInvoiceDetails,
          salesInvoiceList
        );
        if (result) {
          yield put(createPurchaseInvoiceListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPurchaseInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePartiesSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PURCHASE_INVOICE),
    });
    const { salesInvoiceList } = update || {};

    if (update) {
      try {
        const result = yield call(
          updatePurchaseInvoiceDetails,
          salesInvoiceList
        );
        if (result) {
          yield put(updatePurchaseInvoiceListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updatePurchaseInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_PURCHASE_INVOICE),
    });
    const { salesInvoiceList } = create || {};

    if (create) {
      try {
        const result = yield call(
          deletePurchaseInvoiceDetails,
          salesInvoiceList
        );
        if (result) {
          yield put(deletePurchaseInvoiceListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deletePurchaseInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesCategorySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PURCHASE_INVOICE_CATEGORY),
    });
    const { explicitLoad } = load;
    const { categoryList } = explicitLoad || {};
    yield put(loadPartiesCategory(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesCategoryDetails, categoryList);
        // console.log(result, "result");
        if (result) {
          yield put(loadPartiesCategorySuccess(result));
          // console.log(result, "result");
        }
      } catch (error) {
        yield put(
          loadPartiesCategoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesCategorySaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY),
    });
    const { categoryList } = create || {};

    if (create) {
      try {
        const result = yield call(createPartiesCategoryDetails, categoryList);
        if (result) {
          yield put(createPartiesCategoryListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartiesCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPurchaseInvoiceMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_PURCHASE_INVOICE_RECORDS_META_DATA),
    });

    try {
      const barcode = yield call(loadRecordsMetaData, "getbarcode", "post");
      const state = yield call(loadRecordsMetaData, "getstate", "post");

      let recordsMetaData = {
        barcodeOptions:
          (barcode &&
            barcode &&
            barcode.length > 0 &&
            barcode.map((c) =>
              Object.assign(
                {},
                {
                  label: c.barcodeName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        stateOptions:
          (state &&
            state &&
            state.length > 0 &&
            state.map((c) =>
              Object.assign(
                {},
                {
                  label: c.stateName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        // currencyOptions:
        //   (currency &&
        //     currency &&
        //     currency.length > 0 &&
        //     currency.map((c) =>
        //       Object.assign(
        //         {},
        //         {
        //           label: c.currencyName,
        //           shortCode: c.shortCode,
        //           value: c._id,
        //         }
        //       )
        //     )) ||
        //   [],
      };

      yield put(loadPurchaseInvoiceRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadPurchaseInvoiceRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadPurchaseInvoiceSaga(),
    loadPurchaseBarcodeSaga(),
    loadPurchasePrintReceiptSaga(),
    loadPurchaseImportRamListSaga(),
    loadPurchaseBarcodeUpdateDetailsSaga(),
    loadScanBarcodeDetailsSaga(),
    deletePartiesSaga(),
    updatePartiesSaga(),
    createPartiesSaga(),
    loadPurchaseInvoiceMetaDataSaga(),
    loadPartiesTransactionSaga(),
    createPartiesCategorySaga(),
    createPartyVendorAddressSaga(),
    loadPartyVendorAddressSaga(),
    loadPartiesCategorySaga(),
    loadDashboardTransactionsSaga(),
    loadPurchaseTotalDetailsSaga(),
    loadTotalPaidSaga(),
    loadTotalUnPaidSaga(),
  ]);
}
